/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';
import {useTranslation} from 'react-i18next';

import {AwesomeIcon} from '@dvrd/dvr-controls';

import {BolmateBadge} from '../../controls';

import {readNotificationChannels} from '../../../util/pushChannelUtil';
import Notification from '../../../models/notificationModel';

interface Props {
    notification: Notification;
}

/** Small channel-indicator badge shown next to a notification's title: an
 *  envelope for e-mail delivery and a bell for web-push, reflecting the
 *  notification's active channels. */
export default function NotificationChannelsBadge(props: Props) {
    const {t} = useTranslation();
    const {notification} = props;
    const channels = readNotificationChannels(notification);
    const hasEmail = channels.includes('EMAIL');
    const hasPush = channels.includes('WEB_PUSH');
    if (!hasEmail && !hasPush) return null;

    let tooltip: string;
    if (hasEmail && hasPush) tooltip = t('notifications.components.channelsEmailPush', 'E-mail en push-melding');
    else if (hasPush) tooltip = t('notifications.components.channelsPush', 'Push-melding');
    else tooltip = t('notifications.components.channelsEmail', 'E-mail');

    return (
        <BolmateBadge
            outline
            color='gold'
            tooltip={tooltip}
            className='channels-badge'
            label={
                <span className='channels-badge-icons'>
                    {hasEmail && <AwesomeIcon name='envelope' />}
                    {hasPush && <AwesomeIcon name='bell' />}
                </span>
            }
        />
    );
}
